import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  IconButton,
  useTheme,
  alpha,
  Alert
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import MemberTypeManager from '../components/MemberTypeManager';

const AdminMemberTypesPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const theme = useTheme();

  if (user?.role !== 'admin') {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert severity="warning">
          This page is only accessible to administrators.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Back Button */}
      <Box sx={{ mb: 2 }}>
        <IconButton 
          onClick={() => navigate('/admin')}
          sx={{ 
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) }
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>

      {/* Member Type Manager Component */}
      <MemberTypeManager />
    </Container>
  );
};

export default AdminMemberTypesPage;